// import React from 'react';
import { colors } from '../../../../utils/Colors';

const Footer = () => {
  return (
    <footer 
      className="text-center py-3" 
      style={{ backgroundColor: colors.PRIMARY }}
    >
      <p className="text-light mb-0" style={{ fontSize: '0.9rem', opacity: 0.9 }}>
        &copy; {new Date().getFullYear()} RONAQ BANQUETS. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;